import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

export interface CartItem {
  id: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  quantity: number;
  image?: string;
}

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {
  @Output() continueToCheckout = new EventEmitter<CartItem[]>();
  @Output() addMoreItems = new EventEmitter<void>();

  cartItems: CartItem[] = [
    {
      id: 'placeholder-1',
      name: 'Platzhalter',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      price: 13.50,
      currency: 'CHF',
      quantity: 1,
      image: 'assets/images/product-placeholder.jpg'
    },
    {
      id: 'placeholder-2', 
      name: 'Platzhalter',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      price: 13.50,
      currency: 'CHF',
      quantity: 1,
      image: 'assets/images/product-placeholder.jpg'
    }
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    this.calculateTotal();
  }

  // Quantity Management
  increaseQuantity(item: CartItem) {
    item.quantity++;
    this.calculateTotal();
  }

  decreaseQuantity(item: CartItem) {
    if (item.quantity > 1) {
      item.quantity--;
      this.calculateTotal();
    }
  }

  // Remove item from cart
  removeItem(item: CartItem) {
    const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id);
    if (index > -1) {
      this.cartItems.splice(index, 1);
      this.calculateTotal();
    }
  }

  // Calculate total price
  calculateTotal(): number {
    return this.cartItems.reduce((total, item) => {
      return total + (item.price * item.quantity);
    }, 0);
  }

  // Format price with currency
  formatPrice(price: number, currency: string = 'CHF'): string {
    return `${price.toFixed(2)} ${currency}`;
  }

  // Navigation actions
  onAddMoreItems() {
    this.addMoreItems.emit();
    this.router.navigate(['/menu']);
  }

  onContinue() {
    if (this.cartItems.length > 0) {
      this.continueToCheckout.emit(this.cartItems);
      this.router.navigate(['/order-type']);
    }
  }

  // Helper methods
  get totalPrice(): number {
    return this.calculateTotal();
  }

  get itemCount(): number {
    return this.cartItems.reduce((count, item) => count + item.quantity, 0);
  }

  get isEmpty(): boolean {
    return this.cartItems.length === 0;
  }

  // TrackBy function for ngFor optimization
  trackByItemId(index: number, item: CartItem): string {
    return item.id;
  }
}